import React, { useState } from 'react';
import CalendarStandaloneForm from "./CalendarStandaloneForm";

const CalendarForm = ({ title, close, submit }) => {

    // Отмеченные дни для копирования записи
    const [selectDays, setSelectDays] = useState([]);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ close }/>
                        <div className="form__title">{ title }</div>
                    </div>
                    <div className="form__field">
                        <CalendarStandaloneForm
                            handler={ date => {
                                // Копируем массив с отмеченными датами
                                let selectDaysCopy = [...selectDays];
                                // Ищем индекс даты
                                let findInd = selectDaysCopy.findIndex(el => el === date);

                                if (findInd + 1) {
                                    selectDaysCopy.splice(findInd, 1);
                                }
                                else {
                                    selectDaysCopy.push(date);
                                }

                                setSelectDays(selectDaysCopy);
                            } }
                            selectedDays={ selectDays }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button" onClick={ () => submit(selectDays) }>Копировать</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CalendarForm;